import { MdCallEnd } from 'react-icons/md';
import Button from '../../../buttons/button';
import { PhoneControlButtonProps } from '../types';

export const EndCallButton: React.FC<PhoneControlButtonProps> = ({
  onClick,
  disabled,
  size = 'md',
}) => {
  return (
    <Button
      variant="danger"
      appearance="soft"
      size={size}
      onClick={onClick}
      disabled={disabled}
      className="rounded-full flex-shrink-0"
      isIconOnly
    >
      <MdCallEnd className="w-5 h-5" />
    </Button>
  );
};
